import PricesList from 'components/Lists/ListView/PricesList';
import RestaurantsList from 'components/Lists/ListView/RestaurantsList';
import Text from 'components/Text/Text';
import React from 'react';
import ImgUploaderByEntityId from 'components/ImgUploader/ImgUploaderByEntityId';
import CategoriesList from './components/CategoriesList';
import SubCategoriesList from './components/SubCategoriesList';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import { DraggableProvidedDragHandleProps } from 'react-beautiful-dnd';
import { RequestEntity, IDishPositionItem } from 'types';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IItem {
	data: IDishPositionItem;
	positionNumber: number;
	dragHandleProps: DraggableProvidedDragHandleProps | undefined;
}

const Item: React.FC<IItem> = ({ data, positionNumber, dragHandleProps }) => {
	const containerClasses = classNames(style.container);
	const nameRowClasses = classNames(style.name, style.row);
	const imgWrapperClass = classNames(style.imgWrapper);
	const dishNameClasses = classNames(style.dishName);
	const categoryRowClasses = classNames(style.category, style.row, style.list);
	const subCategoryRowClasses = classNames(style.subCategory, style.row, style.list);
	const restaurantRowClasses = classNames(style.restaurant, style.row, style.list);
	const isDisabledRowClasses = classNames(style.isDisabled, style.row, style.list);
	const priceRowClasses = classNames(style.price, style.row, style.list);

	const restaurants = data.restaurants.map((el) => ({
		...el,
		restaurantName: el.name,
	}));

	const isDisabledRestaurants = restaurants.filter((el) => el.isDisabled);

	return (
		<div className={containerClasses}>
			<div className={nameRowClasses}>
				<div className={style.positionNumber}>{positionNumber}</div>
				<div className={style.dragMark} {...dragHandleProps}>
					<svg>
						<use xlinkHref={`${breadcrumbs}#dragMark`} />
					</svg>
				</div>
				<div className={imgWrapperClass}>
					<ImgUploaderByEntityId
						resource={RequestEntity.Dishes}
						entityID={data.filePath ? data.id : ''}
						photoSize="Small"
						loaderSize="small"
					/>
				</div>
				<Text className={dishNameClasses} translationKey={data.name} withTooltip={true} />
			</div>
			<div className={categoryRowClasses}>
				<CategoriesList data={data.categories} />
			</div>
			<div className={subCategoryRowClasses}>
				<SubCategoriesList data={data.subCategories} />
			</div>
			<div className={restaurantRowClasses}>
				<RestaurantsList restaurants={restaurants} />
			</div>
			<div className={isDisabledRowClasses}>
				<RestaurantsList restaurants={isDisabledRestaurants} />
			</div>
			<div className={priceRowClasses}>
				<PricesList restaurants={restaurants} />
			</div>
		</div>
	);
};

export default Item;
